module.exports = "/_next/static/images/bcde49e39eae22dd662bf4adace236d5-debit-phase-5.svg.webp";